import React from 'react'
import Header from "./PageHeader";
import headerbg from "../bg.jpg";
import { Col, Container, Row } from 'react-bootstrap';
import MainHeading from './MainHeading';
export default function Pricing() {
  return (
    <>
    <Header backgroundImage={headerbg} title="Pricing " caption="Affordable Plans Tailored for Every Institution – Unlock the Full Potential of Your Education Management System with Transparent Pricing!" />
    <section>
      <Container>
        <Row>
          <Col>
            <MainHeading title="Pricing"/>
          </Col>
        </Row>
      </Container>
    </section>
    </>
    
  )
}
